import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope) {
    /**
     * Homeowners line of business specific values to be made available on the fnol object
     */

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {};

    return ctrl.create($scope);
};
fn.$inject = ['$scope'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ho/controllers/HOBaseFnolWizardCtrl.js
// module id = 1549
// module chunks = 0